import React from 'react'
import { injectIntl, FormattedMessage, WrappedComponentProps } from 'react-intl'
import { LinkText } from 'shared-global-ec-uikit/components/dist/react/esm/components/link-text'
import { Body } from 'shared-global-ec-uikit/components/dist/react/esm'

export type Props = {
  onSeeAllStores: () => void
}

const SeeAllStores = ({ onSeeAllStores }: Props & WrappedComponentProps) => (
  <LinkText
    element="button"
    variant="standalone"
    emphasize={false}
    onClick={onSeeAllStores}
  >
    <Body
      color="primary-dark"
      element="p"
      textAlign="left"
      textTransform="normal"
      variant="underlined"
    >
      <FormattedMessage id="text_view_all_store" />
    </Body>
  </LinkText>
)

export default injectIntl(SeeAllStores)
